<template>
  <div v-html="html">
    Not found!!
  </div>
</template>

<script>
export default {
  data() {
    return {
      html: ''
    }
  },
  mounted() {
    if (this.configs) {
      this.theme = this.configs.theme
      this.startLoadPage()
    }
  },
  methods: {
    startLoadPage() {
      if (Object.keys(this.messages).length === 0) {
        setTimeout(() => {
          this.startLoadPage()
        }, 50)
        return
      }
      this.loadPage()
    },
    loadPage() {
      this.$router.push('/')
    }
  }
}
</script>
